import React, { useRef, useState } from "react";
import styled from "styled-components";
import { RowElement, RowLayoutStyle } from "../../Sliders/AddSlide";
import { InputField1 } from "../../../InputField1/InputField1";
import Button from "../../../Button/Button";
import { errorMessage } from "../../../../utils/message";
import {
  useAddNewBrand,
  useGetProductList1,
} from "../../../../hooks/useContent";
import Spinner from "react-bootstrap/Spinner";
import Typography from "../../../Typography/Typography";
import { RefreshTableBrand } from "../../../../shared/content-unit";
import { useRecoilState } from "recoil";
import { SimpleSelect1 } from "../../../SimpleSelect/SimpleSelect1";

function BrandGenerator() {
  const [refreshEffect, setRefreshEffect] = useRecoilState(RefreshTableBrand);
  const fileRef = useRef();

  const {
    mutateAsync: addNewBrand,
    isLoading: reqLoading,
    error: reqError,
  } = useAddNewBrand();

  const [newCategory, setNewCategory] = useState({
    name: "",
    en_name: "",
    ar_name: "",
    logo: "",
    category_id: "",
  });

  const { data: listProduct, isLoading: loadingCategorty } =
    useGetProductList1("");

  const initialListProduct = listProduct?.data?.categories?.map((item) => ({
    label: item?.NameCategories,
    value: item?.IdCategories,
  }));

  const isValidImg = (event) => {
    let isValid = true;

    const file = event.target.files[0];
    if (file.type !== "image/svg+xml" || file.size > 0.8e6) {
      file.size > 0.8e6
        ? errorMessage("فایل انتخاب شده بیشتر از 800 مگ است")
        : errorMessage("فایل انتخاب شده با فرمت (svg) نیست");
      isValid = false;
      event.target.value = "";
    }
    return isValid;
  };

  const handleChange = (e) => {
    const { value, name } = e.target;

    if (e.target?.type === "file") {
      const file = e.target.files[0];
      if (isValidImg(e)) {
        setNewCategory({ ...newCategory, [name]: file });
      } else setNewCategory({ ...newCategory, [name]: "" });

      return 3;
    }

    setNewCategory({
      ...newCategory,
      [name]: value,
    });
  };

  const validateForm = () => {
    if (newCategory.name.length < 1) {
      errorMessage("لطفا نام فارسی برند را وارد کنید");
      return false;
    } else if (newCategory.logo.length < 1) {
      errorMessage("لطفا عکس لوگوی را انتخاب کنید");
      return false;
    }
    return true;
  };

  const handleSubmit = () => {
    if (validateForm()) {
      const formData = new FormData();
      formData.append("name", newCategory.name);
      formData.append("en_name", newCategory.en_name);
      formData.append("ar_name", newCategory.ar_name);
      formData.append("logo", newCategory.logo);
      formData.append("category_id", newCategory.category_id);

      addNewBrand(formData).then((res) => {
        setRefreshEffect(!refreshEffect);
        setNewCategory({
          name: "",
          en_name: "",
          ar_name: "",
          logo: "",
          category_id: "",
        });
        fileRef.current.value = "";
      });
    }
  };

  return (
    <LevelGeneratorStyle>
      <GeneratorWrapper>
        <RowLayoutStyle>
          <RowElement>
            <InputField1
              type="text"
              name="name"
              label="نام فارسی"
              onChange={handleChange}
              value={newCategory?.name}
              placeholder="نام فارسی دسته بندی.."
              maxLenght="50"
            />
          </RowElement>
          <RowElement>
            <InputField1
              type="text"
              name="en_name"
              label="نام انگلیسی"
              onChange={handleChange}
              value={newCategory?.en_name}
              placeholder="نام انگلیسی دسته بندی..."
              maxLenght="50"
            />
          </RowElement>
          <RowElement>
            <InputField1
              type="text"
              name="ar_name"
              label="نام عربی"
              onChange={handleChange}
              value={newCategory?.ar_name}
              placeholder="نام دسته بندی عربی ..."
              maxLenght="50"
            />
          </RowElement>
        </RowLayoutStyle>
        <RowDiv>
          <RowElement>
            <InputField1
              type="file"
              name="logo"
              refInput={fileRef}
              label="لوگو"
              onChange={handleChange}
              placeholder="لوگو"
              maxLenght="50"
            />
          </RowElement>

          <RowElement>
            <SimpleSelect1
              label="دسته بندی محصول"
              name="category_id"
              res={initialListProduct}
              placeholder={newCategory.category_id}
              onChange={(event) =>
                setNewCategory({ ...newCategory, category_id: event.value })
              }
            />
          </RowElement>
        </RowDiv>
        <Button
          bgColor={"#4c78a9"}
          small={"200px"}
          onclick={(e) => {
            !reqLoading && handleSubmit();
          }}
          color="#fff"
        >
          {reqLoading ? (
            <Spinner animation="border" size="sm" />
          ) : (
            <Typography size={"15px"} primary={"#fff"}>
              ثبت برند
            </Typography>
          )}
        </Button>
      </GeneratorWrapper>
    </LevelGeneratorStyle>
  );
}

const LevelGeneratorStyle = styled.div``;

const GeneratorWrapper = styled.div`
  width: 100%;
  padding: 1rem 2rem;
  background-color: ${({ theme }) => theme.backgroundSidebar};
`;

const RowDiv = styled.div`
  margin-bottom: 2rem;
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  row-gap: 1rem;
  column-gap: 4rem;
  align-items: center;
  justify-content: flex-start;
`;

export default BrandGenerator;
